import React 					from 'react';
import PropTypes 				from 'prop-types';
import BLComponent 				from '../core/_BLComponent.jsx';

import BreadCrumbs 				from '../common/_BreadCrumbs.jsx';
import CustomCheckbox 			from '../common/_CustomCheckbox.jsx';

//this.props.classes			: string of classes
/*this.props.data					: {
																link 			: (optional) string of link
															, image 			: string of image url
															, name 				: string of name
															, itemNumber 		: (optional) string of item number
															, altItemNumber 	: (optional) string of alt item number
															, condition 		: (optional) char for condition mapping 
															, sub condition 	: (optional) char for sub-condition mapping 
															, inventory 		: (optional) url of inventory listing
															, year 				: (optional) integer of year
															, qtyInSet 			: (optional) integer of qty
															, altMatchID 		: (optional) integer of matching ids
															, price 			: (optional) string of price
															, qty 				: (optional) integer of qty
														}*/

//this.props.size					: (optional) large || 

//this.props.breadcrumbs 	: (optional) array of {link: string, content: string}

export default class ProductInventoryListingItem extends BLComponent 
{
	constructor(props) 
	{
		super(props);

		this.state = {
			showAlternate: this.props.showAlternate ? this.props.showAlternate : false
		}

		this.colorArray = ["#606060","#606090","#609090","#60A860","#90A060","#A88860","#A86060","#904860","#906090"]
	}

	componentDidUpdate(prevProps)
	{
		if( this.props.showAlternate != prevProps.showAlternate )
		{
			this.setState({showAlternate: this.props.showAlternate})
		}
	}

	render() {
		const {print} = this.props;

		if(!print) {
			return this.renderListingItem()
		}else{
			return this.renderListingItemPrint()
		}
	}

	renderListingItem() {
		const {classes = '', select, isAlternate = false} = this.props;
		const {link = null, image, name, itemNumber = null, color = false, year = null, breadcrumbs = null, altMatchID = null, qty, idItemInv} = this.props.data;
		const alternates = this.props.alternates;
		const isSelected = select.isChecked;

		const {showAlternate} = this.state;
		const hasAlternate = alternates.length;

		return (
			<article className={"product-inventory-listing-item " + classes}>
				<div className="product-inventory-listing-item__internal">
					{select ? 
						<div className="product-inventory-listing-item__cell product-inventory-listing-item__checkbox">
							<CustomCheckbox isChecked={isSelected} onChangeFunc={this.toggleCheckBox}/>
						</div>
					: null}
					<div className={"product-inventory-listing-item__cell product-inventory-listing-item__image "}>
						{link ?
							<a className="link--inherit" href={link} target={"_blank"}>
								<img src={image} onError={(e) => e.target.src = `//${blapp.config.getHost( "static" )}/clone/img/no_image.png`} className="l-block"/>
							</a>
						:
							<img src={image} onError={(e) => e.target.src = `//${blapp.config.getHost( "static" )}/clone/img/no_image.png`} className="l-block"/>
						}
					</div>
					<div className="product-inventory-listing-item__cell product-inventory-listing-item__cell--split product-inventory-listing-item__qty"><span className="product-inventory-listing-item__cell-label">Qty:</span>{qty}</div>
					<div className="product-inventory-listing-item__cell product-inventory-listing-item__description">
						{link ? 
							<strong className="product-inventory-listing-item__name"><a className="link--inherit" href={link} target={"_blank"}>{name}</a></strong>
						:
							<strong className="product-inventory-listing-item__name">{name}</strong>
						}
						<BreadCrumbs classes="product-inventory-listing-item__breadcrumbs" crumbs={breadcrumbs} clean={true} type={'arrow'}/> 
					</div>
					<div className="product-inventory-listing-item__cell product-inventory-listing-item__cell--split product-inventory-listing-item__item-no"><span className="product-inventory-listing-item__cell-label">Item no.:</span>{itemNumber}</div>
					<div className="product-inventory-listing-item__cell product-inventory-listing-item__cell--split product-inventory-listing-item__inv-no"><span className="product-inventory-listing-item__cell-label">Inv. ID:</span>{idItemInv}</div>
					{altMatchID > 0 && <div className="product-inventory-listing-item__cell product-inventory-listing-item__cell--split product-inventory-listing-item__mid"><span className="product-inventory-listing-item__cell-label">Match ID:</span><span>{altMatchID}</span><i className="color-swatch color-swatch--medium color-swatch--rounded l-margin-left--sm" style={{background:this.colorArray[altMatchID % 8]}}/></div>}
					{hasAlternate ? 
						<React.Fragment>
							<div className="product-inventory-listing-item__cell product-inventory-listing-item__alternate-trigger"><button className="btn btn--blank text--small" onClick={() => this.setState({showAlternate: !this.state.showAlternate})}>{isAlternate ? 'Is alternate for' :'Alternate items'}<i className={`fas fa-caret-${showAlternate ? 'up' : 'down'} l-margin-left--sm text-color--primaryBlue `}/></button></div>
							{showAlternate ? 
								<div className="product-inventory-listing-item__cell product-inventory-listing-item__alternate">
									{this.renderAlternates()}
								</div>
							: null}
						</React.Fragment>
					: null}
				</div>
			</article>
		);
	}

	renderAlternates() {
		const {alternates} = this.props;

		return alternates.map(item => {
			const {link = null, image, name, itemNumber = null, color = false, year = null, breadcrumbs = null, altMatchID = null, qty, idItemInv} = ProductInventoryListingItem.getDataFromItemInv(item, true);

			return (
				<article key={itemNumber} className={"product-inventory-listing-item-alternate "}>
					<div className="product-inventory-listing-item-alternate__internal">
						<div className={"product-inventory-listing-item__cell product-inventory-listing-item__image"}>
							{link ?
								<a className="link--inherit" href={link} target={"_blank"}>
									<img src={image} onError={(e) => e.target.src = `//${blapp.config.getHost( "static" )}/clone/img/no_image.png`} className="l-block"/>
								</a>
							:
								<img src={image} onError={(e) => e.target.src = `//${blapp.config.getHost( "static" )}/clone/img/no_image.png`} className="l-block"/>
							}
						</div>
						<div className="product-inventory-listing-item__cell product-inventory-listing-item__cell--split product-inventory-listing-item__qty"><span className="product-inventory-listing-item__cell-label">Qty:</span>{qty}</div>
						<div className="product-inventory-listing-item__cell product-inventory-listing-item__description">
							{link ? 
								<strong className="product-inventory-listing-item__name"><a className="link--inherit" href={link} target={"_blank"}>{name}</a></strong>
							:
								<strong className="product-inventory-listing-item__name">{name}</strong>
							}
							<BreadCrumbs classes="product-inventory-listing-item__breadcrumbs" crumbs={breadcrumbs} clean={true} type={'arrow'}/> 
						</div>
						<div className="product-inventory-listing-item__cell product-inventory-listing-item__cell--split product-inventory-listing-item__item-no"><span className="product-inventory-listing-item__cell-label">Item no.:</span>{itemNumber}</div>
						<div className="product-inventory-listing-item__cell product-inventory-listing-item__cell--split product-inventory-listing-item__inv-no"><span className="product-inventory-listing-item__cell-label">Inv. ID:</span>{idItemInv}</div>
						<div className="product-inventory-listing-item__cell product-inventory-listing-item__cell--split product-inventory-listing-item__mid"><span className="product-inventory-listing-item__cell-label">Match ID:</span><span>{altMatchID}</span><i className="color-swatch color-swatch--medium color-swatch--rounded l-margin-left--sm" style={{background:this.colorArray[altMatchID % 8]}}/></div>
					</div>
				</article>
			);
		});
	}

	renderListingItemPrint() {
		const {classes = '', isAlternate = false} = this.props;
		const {link = null, image, name, itemNumber = null, color = false, year = null, breadcrumbs = null, altMatchID = null, qty, idItemInv} = this.props.data;
		const alternates = this.props.alternates;

		const {showAlternate} = this.state;
		const hasAlternate = alternates.length;

		return (
			<article className={"product-inventory-listing-item product-inventory-listing-item--print " + classes}>
				<div className="product-inventory-listing-item__internal product-inventory-listing-item__internal--print">
					<div className={"product-inventory-listing-item__cell product-inventory-listing-item__image "}>
						<img src={image} onError={(e) => e.target.src = `//${blapp.config.getHost( "static" )}/clone/img/no_image.png`} className="l-block"/>
					</div>
					<div className="product-inventory-listing-item__cell product-inventory-listing-item__qty">{qty}</div>
					<div className="product-inventory-listing-item__cell product-inventory-listing-item__description">
						<strong className="product-inventory-listing-item__name">{name}</strong>
						<BreadCrumbs classes="product-inventory-listing-item__breadcrumbs" crumbs={breadcrumbs} clean={true} type={'arrow'}/> 
					</div>
					<div className="product-inventory-listing-item__cell product-inventory-listing-item__item-no">{itemNumber}</div>
					<div className="product-inventory-listing-item__cell product-inventory-listing-item__inv-no">{idItemInv}</div>
					{altMatchID > 0 && <div className="product-inventory-listing-item__cell product-inventory-listing-item__mid"><span>{altMatchID}</span><i className="color-swatch color-swatch--medium color-swatch--rounded l-margin-left--sm" style={{background:this.colorArray[altMatchID % 8]}}/></div>}
					{hasAlternate ? 
						<React.Fragment>
							{showAlternate ? 
								<div className="product-inventory-listing-item__cell product-inventory-listing-item__alternate product-inventory-listing-item__alternate--print">
									<strong className="l-block text--uppercase text-color--lightDarkest">Alternate items</strong>
									{this.renderAlternatesPrint()}
								</div>
							: null}
						</React.Fragment>
					: null}
				</div>
			</article>
		);
	}

	renderAlternatesPrint() {
		const {alternates} = this.props;

		return alternates.map(item => {
			const {link = null, image, name, itemNumber = null, color = false, year = null, breadcrumbs = null, altMatchID = null, qty, idItemInv} = ProductInventoryListingItem.getDataFromItemInv(item, true);

			return (
				<article key={itemNumber} className={"product-inventory-listing-item-alternate product-inventory-listing-item-alternate--print"}>
					<div className="product-inventory-listing-item-alternate__internal product-inventory-listing-item-alternate__internal--print">
						<div className="product-inventory-listing-item__cell product-inventory-listing-item-alternate__details">
							<div>
								<img src={image} onError={(e) => e.target.src = `//${blapp.config.getHost( "static" )}/clone/img/no_image.png`} className="l-block"/>
							</div>
							<div className="l-margin-left">
								<strong className="product-inventory-listing-item__name">{name}</strong>
								<BreadCrumbs classes="product-inventory-listing-item__breadcrumbs" crumbs={breadcrumbs} clean={true} type={'arrow'}/> 
							</div>
						</div>
						<div className="product-inventory-listing-item__cell product-inventory-listing-item__item-no">{itemNumber}</div>
						<div className="product-inventory-listing-item__cell product-inventory-listing-item__inv-no">{idItemInv}</div>
						<div className="product-inventory-listing-item__cell product-inventory-listing-item__mid"><span>{altMatchID}</span><i className="color-swatch color-swatch--medium color-swatch--rounded l-margin-left--sm" style={{background:this.colorArray[altMatchID % 8]}}/></div>
					</div>
				</article>
			);
		});
	}

	toggleCheckBox = () => {
		if(this.props.select && this.props.select.onChangeFunc)
			this.props.select.onChangeFunc(this.props.select.idToggle)
	}



	static getDataFromItemInv( dmItemInv, showColorName )
	{
		const 	dmBasic = dmItemInv.dmItem.dmItem;
		let		colorText	= "";
		let ci;

		if ( showColorName && dmBasic.bColorEnabled )
		{
			ci	= blapp.color.get( dmItemInv.dmItem.idColor );

			if ( ci )
				colorText	= "[" + ci.strColorName + "] ";
		}

		return	{
					link:		blapp.url2.getCatalogItemPageUrl( dmBasic, dmItemInv.dmItem.idColor )
				,	image: 		blapp.url2.getCatalogItemImgUrl( dmItemInv.dmItem.dmImg, "T2" )
				,	name:		colorText + dmBasic.strItemName
				,	itemNumber:	dmBasic.strItemNoFull
				,	qty: 		dmItemInv.nQty
				,	color: ci ? ci.strColorName : null
				,	altMatchID:	dmItemInv.idMatch
				,	idItemInv:	dmItemInv.idItemInv
				,	breadcrumbs: ProductInventoryListingItem.getBreadcrumbs(dmBasic)
				}
	}

	static getBreadcrumbs(dmBasic)
	{
		let breadcrumbs = [];
		switch( dmBasic.typeItem )
		{
			case 'P':
				breadcrumbs.push({ content: 'Parts'} );
				break;
			case 'M':
				breadcrumbs.push({ content: 'Minifigures' });
				break;
			case 'S':
				breadcrumbs.push({ content: 'Sets' });
				break;
			default:
				breadcrumbs.push({ content: dmBasic.typeItem });
				break;
		}
		if( dmBasic.strCatStrV2 && dmBasic.strCatStrV2 != '')	
			breadcrumbs = breadcrumbs.concat(blapp.category.getV2ListByCatStr(dmBasic.strCatStrV2).map( b => { return {content : b.strName}}))
		else
			breadcrumbs.push({ content: blapp.util.decodeHtml(blapp.category.getLegacy(dmBasic.strCatStr).strCategoryName) })

		return breadcrumbs;
	}
}

ProductInventoryListingItem.propTypes = 
{
	classes:			PropTypes.string
,	showUnavailable: PropTypes.bool
,	data:				PropTypes.shape(
							{
								link:			PropTypes.string
							,	image:			PropTypes.string.isRequired
							,	name:			PropTypes.string.isRequired
							,	itemNumber:		PropTypes.string
							,	altItemNumber:	PropTypes.string
							,	altMatchID:		PropTypes.number
							,	qty:			PropTypes.number
							,	idItemInv:		PropTypes.number
						}).isRequired
	,	breadcrumbs:	PropTypes.arrayOf(
							PropTypes.shape(
								{
									link:		PropTypes.string.isRequired
								,	content:	PropTypes.string.isRequired
								}
							)
						)
}

var $T = BLComponent.createTextMap(
	{
		"QTY_IN_SET":
		{
			"en":	"Qty in set:"
		,	"kr":	"세트 내 수량:"
		,	"es":	"Cantidad en el set:"
		}
	,	"ALT_MATCH_ID":
		{
			"en":	"Alt match ID:"
		,	"kr":	"대체 식별 번호:"
		,	"es":	"ID alternativo"
		}
	,	"QTY":
		{
			"en":	"Qty:"
		,	"kr":	"수량:"
		,	"es":	"Cantidad:"
		}
	,	"ALMOST_GONE":
		{
			"en":	"Almost gone"
		,	"kr":	"품절 임박"
		,	"es":	"Últimas unidades"
		}
	}
);